import { JSEncrypt } from "jsencrypt";
import SpecificExceptions from "./specific-exceptions";

const domainURL = window.domain_URL_Portal
var token = window.clientToken;
const CEM_KEY = window['CEM_KEY'];

export async function callBackendService(url, requestBody, methodType) {
  let headers = {
    'Content-Type': 'application/json',
    "cem-key": CEM_KEY
  }
  
  let extraHeader = { 'Authorization': 'Bearer ' + token }
  if (extraHeader) {
    headers = { ...headers, ...extraHeader };
  }

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: methodType,
      body: JSON.stringify(requestBody),
      headers: headers
    })
      .then(async res => res.json())
      .then(async (result) => {
        if (result.statusCode && result.statusCode === "MBE_323") {
          token = await reGenerateToken();
          resolve(await callBackendService(url, requestBody, methodType))
        } else if (result.status.code !== 'MAPI-000') {
          if (window.lang === 'en') {
            reject(new SpecificExceptions(result.status.code, result.status.englishDetail))
          } else {
            reject(new SpecificExceptions(result.status.code, result.status.arabicDetail))
          }
        }
        resolve(result);
      }).catch(err => {
        reject(err);
      });
  })
}

export function encrypt(message) {
  const publicKey = window.PK;
  let RSAEncrypt = new JSEncrypt();

  RSAEncrypt.setPublicKey(publicKey);

  let encryptedMessage = RSAEncrypt.encrypt(message);
  return encryptedMessage;
}

export function reGenerateToken() {
  let reGenerateToken = window.reGenerateToken;

  return new Promise((resolve, reject) => {
    fetch(domainURL + '' + reGenerateToken, {
      method: 'POST',
      headers: {
        "Content-type": "text/html; charset=UTF-8",
        "cem-key": CEM_KEY
      }
    }).then(res => res.text())
      .then((result) => {
        resolve(result);
      }).catch(err => {
        reject(err)
      });
  })

}

export function generateAccountToken(username) {
  let generateAccountToken = window.generateAccountToken;
  const encryptedUsername = encrypt(username);
  const url = `${domainURL}${generateAccountToken}?un=${encryptedUsername}`;

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        "Content-type": "text/html; charset=UTF-8",
        "cem-key": CEM_KEY
      }
    }).then(res => res.text())
      .then((result) => {
        resolve(result);
      }).catch(err => {
        reject(err)
      });
  })  
}